import { UserData } from 'NSwag/ServerClient/Client.nswag';
import { Action } from 'redux';

export enum UserDataActionTypes {
    SetUserData = 'SET_USER_DATA'
}

export interface SetUserData extends Action {
    type: UserDataActionTypes.SetUserData;
    userData: UserData;
}